module.exports = "<div class=\"barchart-content\">\n    <h5 class=\"chart-title\"\n        ng-if=\"$ctrl.chartTitle\"\n        ng-bind=\"$ctrl.chartTitle\"\n        title=\"{{$ctrl.chartTitle}}\"></h5>\n    <div class=\"barchart-content-chart\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/ctxBarChart/ctxBarChart.template.html
// module id = 172
// module chunks = 0 1